module.exports = __webpack_public_path__ + "static/h300x375-60cb64ee0cc98673860b92686f029ec7.png";